function Notfound({theme}) {
  return <div className={`${theme.bg}	text-red-400 h-svh text-3xl text-center`}>Page not found!</div>
}

export default Notfound